import { useI18n } from "./localization";

// Compact language switch inspired by the supplied translate-icon reference. It is placed
// in both standalone and embedded shells so every page can change language.
export function LanguageToggle() {
  const { locale, t, toggleLocale } = useI18n();
  const nextLabel = locale === "he" ? "English" : "עברית";
  return (
    <button
      type="button"
      onClick={toggleLocale}
      aria-label={`${t.nav.switchLanguage}: ${nextLabel}`}
      title={`${t.nav.switchLanguage}: ${nextLabel}`}
      style={buttonStyle}
    >
      <span aria-hidden style={iconStyle}>文</span>
      <span aria-hidden style={aStyle}>A</span>
    </button>
  );
}

const buttonStyle: React.CSSProperties = {
  width: 36,
  height: 36,
  border: "none",
  borderRadius: 8,
  background: "#e8eef7",
  color: "#0f766e",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  cursor: "pointer",
  fontWeight: 700,
  flex: "0 0 auto"
};

const iconStyle: React.CSSProperties = {
  fontSize: 15,
  lineHeight: 1,
  transform: "translate(-2px, -2px)"
};

const aStyle: React.CSSProperties = {
  position: "absolute",
  fontSize: 14,
  lineHeight: 1,
  transform: "translate(6px, 6px)"
};
